module.exports = __webpack_public_path__ + "static/media/selectedPortrait.a6f04887.svg";